<template>
  <div>
    <a-modal width="650px"
      title="任务拆分"
      v-model:visible="splitData.visible"
      :maskClosable = "false"
      :afterClose="close"
      :confirm-loading="splitData.loading">
      <div class="flex info">
        <dl style="margin-right:30px">
          <dt>任务编号：</dt>
          <dd>{{ info.number }}</dd>
        </dl>
        <dl>
          <dt>任务名称：</dt>
          <dd>{{ info.name }}</dd>
        </dl>
      </div>
      <div class="info">
        <dl>
          <dt>任务总量：</dt>
          <dd>{{ info.total }}</dd>
        </dl>
      </div>
      <a-form 
        ref="formRef"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 8 }"
        :model="splitForm"
        >
        <div>
          <dl>
            <dt></dt>
            <dd>
              <a-form-item label="子任务图片数量" :rules="{required:true,message:'数量不能为空'}" name="num">   
                <a-input-number :min="1" :max="info.total" autocomplete="off" :precision="0" v-model:value="splitForm.num" :step="1"  />
              </a-form-item>
              <a-form-item label="子任务数" name="purchaseManagerId">
                {{info.subTotal}}
              </a-form-item>
            </dd>
          </dl>
        </div>
      </a-form>
      <template v-slot:footer>
        <a-button key="back" @click="handleCancel">关闭</a-button>
        <a-button v-if="splitData.loading" disabled type="primary" @click="taskSplit">请求中</a-button>
        <a-button v-else type="primary" @click="taskSplit">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>


<script>
import {ref,reactive, onMounted, computed} from "vue";
import {useRoute, useRouter} from 'vue-router'
import { message } from 'ant-design-vue';
import { useStore } from '@/store/index2'
import {statusToCn} from '@/filters'

import {pageForServer,getForEdit,taskApprove,  labelTaskReceive, labelTaskReject, labelTaskSplit,labelTaskAssign,teamMembers} from '@/api/taskRelease'


export default{
  props:['taskId','number','name','total'],
  emits:['close'],
  setup(props, context){
    //debugger
    const splitData = reactive({
      visible:true,
      loading:false
    })

    function handleCancel(){  
      splitData.visible = false
    }


    function close(){
      //splitData.visible = false
      context.emit('close')
    }

    const info = reactive({
      taskId:computed(()=>{
        return props.taskId
      }),
      number:computed(()=>{
        return props.number
      }),
      name:computed(()=>{
        return props.name
      }),
      total:computed(()=>{
        return props.total
      }),
      subTotal:computed(()=>{
        if(splitForm.num){
          if(splitForm.num > info.total){
            return 0
          }else{
            let num = 0
            // num = Math.ceil(info.total /  splitForm.num) >=0 ?  Math.ceil(info.total /  splitForm.num)  : 0
            // return num
            return Math.ceil(info.total /  splitForm.num) 
        
          }
          
        }else{
          return 0
        }
        
      })
    })

    const splitForm = reactive({
      num:1
    })


    const formRef = ref();
    function taskSplit(){
      let params = {
        labelTaskId:info.taskId,
        step:splitForm.num
      }
   
      formRef.value.validate().then(async ()=>{
        splitData.loading = true
        let {data:res} = await labelTaskSplit(params)
        if(res.code == 0){
          message.success(res.msg)
          close()
        }else{
          message.error(res.msg)
        }
        splitData.loading = false
        
      })
    }


    return{   
      formRef,
      splitData,
      handleCancel,
      taskSplit,
      close,
      splitForm,
      info
    }
  }
}
</script>


<style lang="less">
.info{
  dl{
    display: flex;
  }
  .ant-input-number-input-wrap{width: 200px;}
}
</style>
